<script setup lang="ts">
type WhatsappLinkColor = 'green' | 'white';

interface Props {
    color?: WhatsappLinkColor;
}

// PROPS
const { color = 'white' } = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();
const route = useRoute();
const config = useRuntimeConfig();
const { whatsapp } = useFleequidContacts();

// DATA
const whatsappLink = computed(
    () =>
        `https://wa.me/${whatsapp.value.replace(/[^+\d]/g, '')}?text=${encodeURIComponent(tt('whatsapp', { url: `${config.public.frontendBaseUrl}${route.fullPath.split('#')[0]}` }))}`
);
</script>

<template>
    <a :href="whatsappLink" target="_blank">
        <SvgoWhatsappGreen v-if="color === 'green'" class="h-[36px] w-[160px]" :font-controlled="false" filled />
        <SvgoWhatsapp v-else class="h-[36px] w-[160px]" :font-controlled="false" filled />
    </a>
</template>
